<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">商户名称：</span>
        </div>
        <el-input type="text" v-model="formData.mchName" size="small" style="width: 280px" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">商户号：</span>
        </div>
        <el-input type="text" v-model="formData.subMchId" size="small" style="width: 280px" />
      </div>

<!--      <div class="form-line">-->
<!--        <div class="textBox">-->
<!--          <b class="red">*</b>-->
<!--          <span class="line-text">备注：</span>-->
<!--        </div>-->
<!--        <el-input type="text" v-model="formData.memo" size="small" style="width: 280px" />-->
<!--      </div>-->

      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>
    </form>
  </div>
</template>

<script>
  import Breadcrumb from '../../../../components/Breadcrumb/Breadcrumb'
  import TextTitle from '../../../../components/Text/TextTitle'
  import ButtonConfirm from '../../../../components/Button/ButtonConfirm'
  import ButtonCancel from '../../../../components/Button/ButtonCancel'
  import {getObjectURL} from '../../../../utils/toBase64'
  import {bus} from '../../../../utils/bus'
  import {api} from '../../../api/ParkingService'
  import {nError, nSuccess} from '../../../../utils/notice'
  import {errorHandler} from '../../../../utils/errorHandler'

  export default {
    components: {
      ButtonCancel,
      ButtonConfirm,
      TextTitle,
      Breadcrumb},
    name: 'wx-account-modify',
    data () {
      return {
        breadcrumb: [{
          value: '智慧停车',
          name: 'parking-device-management'
        }, {
          value: '收款账户'
        }],
        mainTitle: '修改微信收款账户',
        subheading: '',
        formData: {
          code: '',
          mchName: '',
          subMchId: '',
          memo: '',
        },

        modelList: [
          {
            value: '1',
            label: '普通商户'
          }, {
            value: '2',
            label: '服务商户'
          }
        ],
      }
    },
    created () {
      this.formData.code = this.$route.params.id
      this.getWxMoneyAccountByCode()
    },
    methods: {
      // 获取详情
      getWxMoneyAccountByCode () {
        this.$axios.get(`${api.getWxMoneyAccountByCode}/${this.formData.code}`, {})
          .then(res => {
            let data = res.data.data
            data.model = ''
            this.formData = data
            if (!this.formData.subMchId) {
              this.formData.model = '1'
            } else {
              this.formData.model = '2'
            }
          })
          .catch(errorHandler('获取详情失败'))
      },
      toManagementPage () {
        this.$router.push({
          name: 'parking-wx-account-manage'
        })
      },
      // 确认
      confirm () {
        if (!this.formData.mchName) {
          nError('请输入商户名称')
          return false
        }
        if (!this.formData.subMchId) {
          nError('请输入商户号')
          return false
        }
        this.$axios.post(api.updateWxMoneyAccount, this.formData)
          .then(res => {
            nSuccess('修改成功')
            this.toManagementPage()
          })
          .catch(errorHandler('修改失败'))
      },

      cancel () {
        this.toManagementPage()
      }
    }
  }
</script>

<style scoped>
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
    vertical-align: sub;
  }
  .form-line {
    margin: 20px 0;
    display: flex;
    justify-content: flex-start;
  }
  .form-line>div {
    margin-right: 20px;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 122px;
    line-height: 32px;
    text-align: right;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 110px 0 140px;
    margin: 40px 0 0 0;
    display: flex;
    justify-content: space-between;
  }
  .newly2 {
    display: inline-block;
    width: 250px;
    height: 173px;
    vertical-align: text-top;
    border: 1px dashed #D7D7D7;
    margin-right: 20px;
    position: relative;
  }
  .newly2 span {
    display: block;
    width: 100%;
    color: #999999;
    margin: 0;
    padding: 0;
    text-align: center;
  }
  .newly2 span:first-child {
    font-size: 36px;
    line-height: 120px;
    position: absolute;
    top: 15px;
  }
  .newly2 span:last-child {
    font-size: 14px;
    line-height: 50px;
    position: absolute;
    bottom: 0;
  }
  .upload2 {
    display: inline-block;
    width: 250px;
    height: 173px;
    vertical-align: text-top;
    background-size: 100% 100%;
    position: relative;
  }

  .upload2 img {
    width: 100%;
    height: 100%;
    border-radius: 5px;
  }
  .upload2 b {
    display: inline-block;
    width: 100%;
    line-height: 21px;
    color: white;
    background-color: #989796;
    text-align: center;
    position: absolute;
    bottom: 0;
    opacity: .7;
  }
</style>

<style lang="less">
  .el-switch {
    height: 30px;
  }
</style>




// WEBPACK FOOTER //
// src/view/ParkingService/CollectionAccount/wxAccountConfig/wxAccountModify.vue